module.exports = __webpack_public_path__ + "img/IMG_9022_L_Wood.eb8b9635.jpg";